@if (report(); as report) {
  <h2 class="relative px-[30px] text-center !font-bold mb-3">
    Wallet Report
  </h2>
  <div class="bg-[#B3C0C22B] px-2 pb-[10px] rounded-lg mb-3">
    <p class="flex justify-between items-center min-h-[24px] !mb-0 text-[12px] border-b border-solid border-[#E5E5E5]">
      <span>Report ID</span>
      <span>{{ report.id }}</span>
    </p>
    <p class="flex justify-between items-center min-h-[24px] !mb-1 text-[12px]">
      <span>Report Time</span>
      <span>{{ report.createdDate | date: 'h:mm a, dd/MM/yy' }}</span>
    </p>

    @if (walletRental(); as walletRental) {
      @if (walletRental && (walletRental.status === 'AWAITING_PAYMENT' || walletRental.status === 'EXPIRED' || walletRental.status === 'EXPIRED_BY_TIME' || walletRental.type === 'TRIAL_EXPIRED' || (walletRental.incomingLeft < 1 && walletRental.outcomingLeft < 1))) {
        <div class="flex -mx-2 bg-white rounded-[6px] shadow-1 border border-solid border-[#C93535] mb-2">
          @if (report.isSmartContract) {
            <div
              class="flex flex-col items-center justify-between border-r border-solid border-[#022D35] pt-[10px] pb-2 px-1 w-[96px]">
              <div class="flex items-center justify-center">
                <div class="mr-2 flex items-center justify-center">
                  <img
                    [src]="'assets/icons/network/' + (report.network && report.network | convertNetworkToToken | lowercase) + '.svg'"
                    alt="">
                </div>
                <span
                  class="leading-[1.2] text-[14px] font-bold whitespace-nowrap">{{ (report.network && report.network | convertNetworkToToken) }}</span>
              </div>
              <span class="font-bold text-[10px] text-[#022D35] leading-[1]">Smart-Contract</span>
            </div>
          } @else {
            <div
              class="flex items-center justify-center py-[10px] px-1 w-[96px] border-r border-solid border-[#022D35]">
              <div class="mr-2 flex items-center justify-center">
                <img
                  [src]="'assets/icons/network/' + (report.network && report.network | convertNetworkToToken | lowercase) + '.svg'"
                  alt="">
              </div>
              <div class="flex flex-col">
                <span
                  class="leading-[1.2] text-[14px] font-bold">{{ (report.network && report.network | convertNetworkToToken) }}</span>
              </div>
            </div>
          }
          <div class="flex justify-between py-2 pl-[10px] pr-2 w-calc-96">
            <div class="flex flex-col justify-center w-full">
              <span class="leading-[1.2] text-[#C93535] text-[12px] mb-[2px] flex items-center justify-between">
                <span [ngClass]="{
                  'text-[11px]': currentLang === 'ru',
                  'text-[12px]': currentLang !== 'ru'
                  }">Wallet adress:</span>
                <span class="flex items-center bg-[#C93535] text-white text-[10px] rounded-[29px] py-[3px]"
                      [ngClass]="{
                    'px-[3px]': currentLang === 'ru',
                    'px-[7px]': currentLang !== 'ru'
                  }">AML Monitoring Off</span>
              </span>
              <span class="leading-[1.2] text-[#C93535] ">{{ report.address | cropWithDotsCenter }}</span>
            </div>
          </div>
        </div>
      } @else {
        <ng-container [ngTemplateOutlet]="isSubscribed"></ng-container>
      }
    } @else {
      <ng-container [ngTemplateOutlet]="isSubscribed"></ng-container>
    }


    <ng-template #isSubscribed>
      <div class="flex -mx-2 bg-white rounded-[6px] shadow-1 border border-solid border-[#022D35] mb-2">
        @if (report.isSmartContract) {
          <div
            class="flex flex-col items-center justify-between border-r border-solid border-[#022D35] pt-[10px] pb-2 px-1 w-[96px]">
            <div class="flex items-center justify-center">
              <div class="mr-2 flex items-center justify-center">
                <img
                  [src]="'assets/icons/network/' + (report.network && report.network | convertNetworkToToken | lowercase) + '.svg'"
                  alt="">
              </div>
              <span
                class="leading-[1.2] text-[14px] font-bold whitespace-nowrap">{{ (report.network && report.network | convertNetworkToToken) }}</span>
            </div>
            <span class="font-bold text-[10px] text-[#022D35] leading-[1]">Smart-Contract</span>
          </div>
        } @else {
          <div class="flex items-center justify-center py-[10px] px-1 w-[96px] border-r border-solid border-[#022D35]">
            <div class="mr-2 flex items-center justify-center">
              <img
                [src]="'assets/icons/network/' + (report.network && report.network | convertNetworkToToken | lowercase) + '.svg'"
                alt="">
            </div>
            <div class="flex flex-col">
              <span
                class="leading-[1.2] text-[14px] font-bold">{{ (report.network && report.network | convertNetworkToToken) }}</span>
            </div>
          </div>
        }
        <div class="flex justify-between py-2 pl-[10px] pr-2 w-calc-96">
          <div class="flex flex-col justify-center w-full">
            <span class="leading-[1.2] text-[#94A3A6] text-[12px] mb-[2px]">Wallet adress:</span>
            <span class="leading-[1.2] text-[#94A3A6] ">{{ report.address | cropWithDotsCenter }}</span>
          </div>
          <div class="flex items-center">
            <mat-icon class="!w-[19px] !h-[23px]" [svgIcon]="'shield'"></mat-icon>
          </div>
        </div>
      </div>
    </ng-template>

    <a target="_blank" href="https://t.me/AMLOfficer_support_bot"
       class="flex justify-between items-center rounded-[6px] min-h-[25px] px-3 py-1 mb-2"
       [ngClass]="{'text-white': report.data.risk !== 'MEDIUM'}"
       [class.bg-[#C92F29]]="report.data.risk === 'SEVERE'"
       [class.bg-[#EA3D3D]]="report.data.risk === 'HIGH'"
       [class.bg-[#FFCB10]]="report.data.risk === 'MEDIUM'"
       [class.bg-[#87C05A]]="report.data.risk === 'LOW'"
    >
      <div class="flex items-center">
        <div class="mr-[10px]">
          @switch (report.data.risk) {
            @case ('SEVERE') {
              <img [ngSrc]="'assets/icons/icon-risk-severe.svg'" alt="risk" height="14" width="14">
            }
            @case ('HIGH') {
              <img [ngSrc]="'assets/icons/icon-risk-high.svg'" alt="risk" height="14" width="6">
            }
            @case ('MEDIUM') {
              <img [ngSrc]="'assets/icons/icon-risk-medium.svg'" alt="risk" height="14" width="6">
            }
            @case ('LOW') {
              <img [ngSrc]="'assets/icons/icon-risk-low.svg'" alt="risk" height="12" width="12">
            }
          }
        </div>
        <span class="leading-[1.2] text-[13px]">
          @switch (report.data.risk) {
            @case ('SEVERE') {
              Severe Risk
            }
            @case ('HIGH') {
              High Risk
            }
            @case ('MEDIUM') {
              Medium Risk
            }
            @case ('LOW') {
              Low Risk
            }
          }
        </span>
      </div>
      <div class="flex">
        <span class="leading-[1.2] text-[11px]">
          Ask Compliance →
        </span>
      </div>
    </a>
    @if (report.data.riskReason) {
      <div class="flex flex-col p-2 border border-solid border-[#022D35] rounded-[6px]">
        <span class="mb-1">Risk reason:</span>
        <span
          class="text-[#45525B] opacity-50 leading-[1.3]">{{ report.data.riskReason }}</span>
      </div>
    }
  </div>

  <div>
    @if (report.data; as riskResponse) {
      <mat-tab-group class="report-tabs" animationDuration="0ms">
        @if (riskResponse.exposures && riskResponse.exposures.length > 0) {
          <mat-tab [label]="('Sources') + ' (' + riskResponse.exposures.length + ')'">
            <app-report-exposures class="block mt-3" [exposures]="riskResponse.exposures"
                                  [typeReport]="report.process"></app-report-exposures>
          </mat-tab>
        }
        @if (riskResponse.triggers && riskResponse.triggers.length > 0) {
          <mat-tab [label]="('Triggers') + ' (' + riskResponse.triggers.length + ')'">
            <app-report-triggers class="block mt-3" [riskResponse]="riskResponse"
                                 [typeReport]="report.process"></app-report-triggers>
          </mat-tab>
        }
        @if (riskResponse.cluster || (riskResponse.addressIdentifications && riskResponse.addressIdentifications.length > 0)) {
          <mat-tab [label]="'Important'">
            @if (riskResponse.cluster && riskResponse.addressIdentifications && riskResponse.addressIdentifications.length > 0) {
              <app-report-identification class="block mt-3" [typeReport]="report.process"
                                         [info]="{name: riskResponse.cluster.name, category: riskResponse.cluster.category, description: riskResponse.addressIdentifications[0].description}"></app-report-identification>
            } @else if (riskResponse.cluster) {
              <app-report-identification class="block mt-3" [typeReport]="report.process"
                                         [info]="{name: riskResponse.cluster.name, category: riskResponse.cluster.category, description: ''}"></app-report-identification>
            } @else {
              @if (riskResponse.addressIdentifications; as addressIdentifications) {
                @if (addressIdentifications.length > 0) {
                  <app-report-identification class="block mt-3" [typeReport]="report.process"
                                             [info]="{name: addressIdentifications[0].name, category: addressIdentifications[0].category, description: addressIdentifications[0].description}"></app-report-identification>
                }
              }
            }
          </mat-tab>
        }
      </mat-tab-group>
    }
  </div>

} @else {
  No data
}
